"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NormalizedEntityPrefix = void 0;
var NormalizedEntityPrefix;
(function (NormalizedEntityPrefix) {
    NormalizedEntityPrefix["Project"] = "PROJECT:";
    NormalizedEntityPrefix["Catalog"] = "CATALOG:";
})(NormalizedEntityPrefix || (exports.NormalizedEntityPrefix = NormalizedEntityPrefix = {}));
